import { Input } from "@/components/ui/input";
import { ID_INPUT, secondaryOf } from "@/components/identity/Identity";

export const SC_RELATIONS = ["", "Spouse", "Parent", "Sibling", "Family member", "Colleague", "Manager", "Office reception", "Security / front desk", "Neighbour", "Other"];
const CODES = ["+91", "+1", "+44", "+65", "+971", "+61", "+49", "+81"];
const sel = "h-9 rounded-md border border-slate-300 bg-white px-2 text-[13px]";

export function scInit(a) {
  const s = secondaryOf(a) || {};
  const m = String(s.phone || "").trim().match(/^(\+\d{1,3})\s*(.*)$/);
  return { name: s.name || "", relationship: s.relationship || "", cc: m ? m[1] : "+91", number: m ? m[2] : String(s.phone || ""), legacy: s.source === "LEGACY_ALT_PHONE" };
}

export const scPayload = (s) => ({ name: s.name.trim() || null, relationship: s.relationship || null, phone: s.number.trim() ? `${s.cc} ${s.number.trim()}` : null });

export function SecondaryContactFields({ s, onChange, required }) {
  const set = (k) => (e) => onChange({ ...s, [k]: e.target.value });
  return (
    <div className="rounded-lg border border-sky-100 bg-sky-50/40 p-2" data-testid="rm-secondary">
      <div className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Secondary delivery contact {required ? <span className="text-rose-600">* required by customer policy</span> : <span className="font-normal normal-case">(optional, used only if the employee can't be reached)</span>}</div>
      <div className="mt-1 grid gap-2 sm:grid-cols-2">
        <Input value={s.name} onChange={set("name")} placeholder="Contact name" className={`h-9 text-[13px] ${ID_INPUT}`} data-testid="rm-sc-name" />
        <select value={s.relationship} onChange={set("relationship")} className={sel} data-testid="rm-sc-relationship">{SC_RELATIONS.map((x) => <option key={x} value={x}>{x || "Relationship…"}</option>)}</select>
        <div className="grid grid-cols-[84px_1fr] gap-2 sm:col-span-2">
          <select value={s.cc} onChange={set("cc")} className={sel} data-testid="rm-sc-cc">{CODES.map((c) => <option key={c}>{c}</option>)}</select>
          <Input value={s.number} onChange={set("number")} placeholder={`Secondary mobile${required ? " *" : ""}`} inputMode="tel" className="h-9 text-[13px]" data-testid="rm-sc-phone" />
        </div>
      </div>
      {s.legacy && <div className="mt-1 text-[10.5px] text-amber-700" data-testid="rm-sc-legacy">This number was saved earlier as “Second mobile”. Its owner wasn't recorded, so add a name and relationship if you know them.</div>}
      <div className="mt-1 text-[10.5px] text-slate-500">No messages are sent to this number automatically. Changing it after verification needs re-verification.</div>
    </div>
  );
}
